import { getPublicEnv } from '@/utils/env';

export const GOOGLE_MAPS_CONFIG = {
  staticMapBaseUrl: "https://maps.googleapis.com/maps/api/staticmap",
  directionBaseUrl: "https://www.google.com/maps/dir/",
  apiKey: getPublicEnv('NEXT_PUBLIC_GOOGLE_MAPS_API_KEY') || 'AIzaSyDtOPx_71RpFBPNkX9hcNdM8zeg5FAVaEw',
  GOOGLE_MAPS_ID: getPublicEnv('NEXT_PUBLIC_GOOGLE_MAPS_ID') || "60257c36d150ef41" // Not explicitly shown in UAT, but likely same
};

export const GOOGLE_MAP = {
  BASE_DIRECTION_URL: "https://www.google.com/maps/dir/",
  BASE_MAP_URL: "https://maps.google.com",
};

export const SCRIPT_URLS = {
  tripla: "https://tripla.jp/sdk/javascript/tripla.min.js",
  swiperBundle: "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css",
  instagram: "https://www.instagram.com/embed.js",
};

export const GOTOPASS_URLS = {
  BASE: getPublicEnv('NEXT_PUBLIC_GOTOPASS_BASE_URL') ?? "https://uat.gotopass.jp",
  PROFILE_PATH: "/en/my-page/my-profile",
  BOOKING_HISTORY_PATH: "/en/my-page/booking-confirmation/reservations",
};

export const GOOGLE_API = {
  BASE_URL: "https://maps.googleapis.com/maps/api/place/details/json",
  FIELDS: "rating,user_ratings_total,url,name,formatted_address",
};

export const ASSET_URLS = {
  MEMBER_STAMP_BG:
    "https://imagedelivery.net/Ahwf2rDz3ZiXm1qkpDKg1w/e53a1d13-d214-4c37-8616-316b3b7dac00/public",
};

export const GOOGLE_BASE_URL = "https://www.google.com";

export const MEMBERSHIP_PROMO_VIDEO_URL =
  "https://mystays-upload-prod.s3.ap-northeast-1.amazonaws.com/250528_02_30sec_A_938e68e155.mp4";

export const STATIC_MAP_URL =
  "https://maps.googleapis.com/maps/api/staticmap?center=";

export const ICO_MOON_URL = "https://icomoon.io/app";

export const GTM_CONFIG = {
  ID: getPublicEnv('NEXT_PUBLIC_GTM_ID') ?? "GTM-TQBWSJ",
  BASE_URL: "https://www.googletagmanager.com",
};

export const WOVN_CONFIG = {
  SRC: "https://j.wovn.io/1",
  KEY: getPublicEnv('NEXT_PUBLIC_WOVN_KEY') ?? "FnKV6Q",
  VERSION: getPublicEnv('NEXT_PUBLIC_WOVN_VERSION') ?? "WOVN.proxy_0.24.5",
  DEFAULT_LANG: "ja",
};

export const CAPILLARY_API_URL =
  getPublicEnv('NEXT_PUBLIC_CAPILLARY_API_URL') ??
  "https://sea.api.capillarytech.com/mobile/v2/api/lookup/customerDetails?embed=customerstatus%2Cpoints";

export const BANNER_CONTENT_IMAGE_URL = "https://picsum.photos/2287/1286";

export const AUTH0_CONFIG = {
  client_id: process.env.AUTH0_CLIENT_ID ?? '',
  issuer_base_url: process.env.AUTH0_ISSUER_BASE_URL ?? '',
  base_url: process.env.AUTH0_BASE_URL ?? '',
  auth0_audience: process.env.AUTH0_AUDIENCE ?? 'AR1234',
  base_entity_code: process.env.BASE_ENTITY_CODE ?? 'mhm_8888'
};

export const CLIENT_ENV = process.env.NEXT_PUBLIC_NODE_ENV || 'development';
export const ENABLE_AUTH = process.env.ENABLE_AUTH === 'true' || false;
export const UTM_COOKIE_EXPIRY = process.env.UTM_COOKIE_EXPIRY_IN_SECONDS ?? 604800;



export const TRIPLA_CONFIG = {
  tripla_auth_idp_base_url: process.env.CLIENT_SESSION_TRIPLA_URL ?? 'https://idp.staging.tripla.ai',
  tripla_idp_key: process.env.TRIPLA_KEY || '95c4c740baf34b0',
  tripla_idp_secret: process.env.TRIPLA_SECRET || '49edc0373a99c2d7',
  tripla_reservations_base_url: process.env.TRIPLA_API_URL ?? 'https://endpoint.staging.tripla.ai',
  tripla_signin_hotel_id: process.env.TRIPLA_SIGNIN_HOTEL_ID ?? 114,
}
